/* eslint import/no-unresolved: 0 */
// @ts-ignore
import version from './version';
export default version;